export default __webpack_public_path__ + "static/media/red.ef65821f.png";